import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-foreground-200 rounded-full text-xs font-medium text-foreground-600 mb-4">
            Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            14 Curated
            <br />
            Product Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto">
            Every category is hand-picked and regularly updated with the best pandabuy spreadsheet links.
          </p>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.href}
              target="_blank"
              rel="noopener nofollow"
              data-product-shop
              className="group flex flex-col bg-white border border-background-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Category Image */}
              <div className="relative w-full aspect-[4/3] bg-background-100 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              {/* Card Content */}
              <div className="p-4 md:p-4 flex flex-col gap-1.5">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-background-100 group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.icon} text-base text-primary-500 group-hover:text-primary-600 transition-colors`}></i>
                </span>
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap leading-tight">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-500 mt-1 whitespace-nowrap">
                  View Items <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}